import {
  LayoutDashboard,
  FolderOpen,
  ListChecks,
  PlusCircle,
  Settings,
  KeyRound,
  GraduationCap,
  Calculator,
  LibraryBig,
  BookMarked,
  ShieldCheck,
  BookOpen,
  Code,
  Languages,
  LogOut,
} from "lucide-react";

/**
 * Sidebar navigation schema.
 * Each item may have an optional `children` array for accordion sub-menus.
 * `id` values map directly to the `viewMode` state in AdminDashboard.
 */
const sidebarConfig = [
  {
    id: "overview",
    label: "Overview",
    icon: LayoutDashboard,
  },
  {
    id: "projects",
    label: "Projects",
    icon: FolderOpen,
    children: [
      {
        id: "projectList",
        label: "Project List",
        icon: ListChecks,
      },
      {
        id: "project",
        label: "Create Project",
        icon: PlusCircle,
      },
    ],
  },
  {
    id: "study",
    label: "Study",
    icon: GraduationCap,
    children: [
      {
        id: "math",
        label: "Math",
        icon: Calculator,
        children: [
          {
            id: "mathLibrary",
            label: "Math Library",
            icon: LibraryBig,
          },
          {
            id: "mathCourses",
            label: "Math Courses",
            icon: BookMarked,
          },
          {
            id: "mathAccess",
            label: "Math Access",
            icon: ShieldCheck,
          },
        ],
      },
      {
        id: "theology",
        label: "Theology",
        icon: BookOpen,
        children: [
          {
            id: "theologyAccess",
            label: "Theology Access",
            icon: ShieldCheck,
          },
        ],
      },
      {
        id: "cs",
        label: "CS",
        icon: Code,
        children: [
          {
            id: "csDataSciencePassword",
            label: "Data Science Password",
            icon: KeyRound,
          },
        ],
      },
      {
        id: "spanish",
        label: "Spanish",
        icon: Languages,
        children: [
          {
            id: "spanishExamPassword",
            label: "Exam Password",
            icon: KeyRound,
          },
        ],
      },
    ],
  },
  {
    id: "settings",
    label: "Settings",
    icon: Settings,
  },
];

export const bottomConfig = [
  {
    id: "logout",
    label: "Logout",
    icon: LogOut,
    danger: true,
  },
];

export default sidebarConfig;
